import { h } from 'preact'
import FirebaseComponent from './FirebaseComponent'
import DatePicker from 'react-datepicker';
import { createFirebaseItem } from './firebase-helpers'
import * as firebase from 'firebase'
import { Typeahead } from 'react-bootstrap-typeahead'
import { countries, countryToCountryCode } from './country-to-countrycode'

class CreateVisa extends FirebaseComponent {
  constructor() {
		super()

    this.state = {
      countryOfIssue: '',
      endDate: '',
      momentEndDate: null,
      loading: false
    }

    this.handleValueChange = this.handleValueChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.loadingSpinner = this.loadingSpinner.bind(this)
    this.createVisa = this.createVisa.bind(this)
  }

  handleValueChange(event) {
    this.setState({[event.target.name]: event.target.value})
  }

  handleDateChange(momentEndDate) {
    this.setState({ momentEndDate, endDate: momentEndDate.format() })
  }

  loadingSpinner() {
    if (this.state.loading) return <i className="fa fa-spinner fa-spin" style={{ 'font-size': '24px' }}></i>
  }

  createVisa(event) {
    event.preventDefault()
    this.setState({ loading: true })

    createFirebaseItem('visas', {
      account: this.state.uid,
      endDate: this.state.endDate,
      countryOfIssue: this.state.countryOfIssue[0],
      countryCode: countryToCountryCode(this.state.countryOfIssue[0]),
      passport: this.props.passport.id
    }).then(visaId => {
      firebase.database().ref(`passports/${this.props.passport.id}/visas/${visaId}`).set(true)
        .then(() => {
          this.typeahead.getInstance().clear()
          this.setState({ countryOfIssue: '', endDate: '', momentEndDate: null, loading: false})
        })
    })
  }

  render() {
    if (this.props.passport) {
      const country = this.props.passport.countryOfIssue.toUpperCase()
      return (
        <div>
          <form>
            <div className="form-group">
              <Typeahead
                ref={typeahead => this.typeahead = typeahead}
                name="countryOfIssue"
                className="title-typeahead"
                onInputChange={selected => { this.setState({ countryOfIssue: [selected] }) }}
                options={countries}
                placeholder="Country of Issue"
                selected={this.state.selected}
              />
              <DatePicker
                name="endDate"
                selected={this.state.momentEndDate}
                onChange={this.handleDateChange}
                placeholderText="End Date"
                className="form-control"
              />
            </div>
            <button
              className="btn btn-primary btn-sm btn-block"
              onClick={this.createVisa}
              type="submit">{this.loadingSpinner()} ADD VISA TO {country} PASSPORT</button>
          </form>
        </div>
      )
    }
  }
}

export default CreateVisa



// WEBPACK FOOTER //
// ./src/CreateVisa.js